import React, { useState, useEffect, useCallback } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { calculateTimeFromMS } from "../../util/common";

function ProgressBar({ StartTime, averageRunTimeInMS }) {
  const [progress, setProgress] = useState(0);
  const [endTimeMS, setEndTimeMS] = useState(0);
  const [stopCalculation, setStopCalculation] = useState(false);
  const [displayedTime, setDisplayedTime] = useState("");

  const updateDisplayTime = useCallback(() => {
    let currentTime = Date.now();
    if (endTimeMS) {
      if (currentTime > endTimeMS) {
        // Calculate the time passed from endtime and display passed time
        const timeDifference = calculateTimeFromMS(currentTime - Math.max(0, endTimeMS));
        setDisplayedTime(`${timeDifference} longer than usual`);
      }
    }
  }, [endTimeMS]);

  useEffect(() => {
    const interval = setInterval(() => {
      // if no avg time that means no need to calculate the progress
      if (averageRunTimeInMS === null || averageRunTimeInMS === undefined) {
        setProgress(99);
        clearInterval(interval);
      } else {
        if (!stopCalculation) {
          // Get StartTime miliseconds and calculate endtime based on avg time
          const start = new Date(StartTime).getTime();
          const endTime = start + averageRunTimeInMS;
          setEndTimeMS(endTime);

          const currentUTCTimeStamp = Date.now();
          const currentTimeMS = isNaN(currentUTCTimeStamp) ? null : currentUTCTimeStamp;

          // Calculate the elapsed time in milliseconds
          const timer = currentTimeMS > endTime ? averageRunTimeInMS : currentTimeMS - start;
          const elapsedMillis = Math.max(0, timer);

          // Calculate the progress as a percentage
          let newProgress = (elapsedMillis / averageRunTimeInMS) * 100;

          // if somthing is not right then setting newprogress to 100 (this may show job as stuck)
          if (isNaN(newProgress)) newProgress = 100;

          // Ensure progress does not exceed 100%
          setProgress(Math.min(newProgress, 99));

          // When the progress reaches 100% no need to calculate the progress
          if (newProgress >= 100) setStopCalculation(true);
        }

        // Update the displayed time difference regardless of progress% and clear the interval only when component unmount
        // This ensures continue updates for progress taking longer than usual time
        updateDisplayTime();
      }
    }, 1000); // Update every second

    return () => clearInterval(interval);
  }, [StartTime, averageRunTimeInMS, stopCalculation, updateDisplayTime]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%", mr: 1 }}>
          <LinearProgress variant="determinate" value={progress} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">{`${Math.round(progress)}%`}</Typography>
        </Box>
      </Box>
      {displayedTime !== "" && (
        <Box>
          <Typography variant="body2" color="text.secondary">
            {displayedTime}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default ProgressBar;
